export function isLeadCaptureFlagEnabled(value: string | undefined): boolean {
  return value === 'true';
}

export function createLeadIdempotencyKey(): string {
  const randomUUID = globalThis.crypto?.randomUUID?.bind(globalThis.crypto);
  if (!randomUUID) {
    throw new Error('Lead capture requires browser UUID support.');
  }
  return randomUUID();
}

// Visitor copy for the mailto fallback. A deliberate compliance gate
// (`lead_capture_disabled`) is not an outage, so it must not read as one.
export function mailtoFallbackMessage(error: unknown, email: string): string {
  const code = typeof error === 'object' && error !== null ? (error as { code?: unknown }).code : undefined;
  if (code === 'lead_capture_disabled') {
    return `Online aanvragen via de site staan nog niet open. Je e-mailprogramma opent met ${email} als ontvanger.`;
  }
  return `We konden je aanvraag nu niet online verwerken. Je e-mailprogramma opent als fallback met ${email} als ontvanger.`;
}
